import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { CheckIcon } from 'lucide-react'

import { cn } from '~shared/utils/cn'

export type CheckboxProps = React.ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
> & {
  variant?: 'primary' | 'secondary'
  invalid?: boolean
}

export const Checkbox = ({
  className,
  variant = 'primary',
  invalid,
  ...props
}: CheckboxProps) => {
  return (
    <CheckboxPrimitive.Root
      data-slot='checkbox'
      className={cn(
        'peer text-primary data-[state=checked]:bg-accent data-[state=checked]:border-accent focus-visible:border-tertiary aria-invalid:ring-danger aria-invalid:border-danger size-[20px] shrink-0 rounded-[6px] border shadow-xs transition-shadow outline-none focus-visible:ring-[1px] focus-visible:ring-tertiary disabled:cursor-not-allowed',
        variant === 'primary' && 'bg-[#D9D9D9] border-[#D9D9D9]',
        variant === 'secondary' && 'bg-secondary border-secondary',
        className
      )}
      aria-invalid={!!invalid}
      {...props}>
      <CheckboxPrimitive.Indicator
        data-slot='checkbox-indicator'
        className='flex items-center justify-center text-current transition-none'>
        <CheckIcon className='size-[9px]' />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}
